export function Contact() {
  return (
    <h1 className="text-center">Contact</h1>
  )
}